import { useFormContext } from 'react-hook-form';
import { useTranslation } from '@/i18n';
import { Label } from '@/components/ui/label';
import { YesNoStyledRadioGroup } from '@/components/styled/StyledRadioGroup';
import { HotelFormDataWithTranslations } from '@/i18n/translation-type-utils';

/**
 * "Voulez-vous coller les tarifs depuis Excel (mode Expert) ?" Saved with
 * the hotel, so the sheet reopens in the mode it was filled in. It only
 * shows the paste zones: room compositions are ticked by the pastes.
 */
const ExpertModeToggle = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<HotelFormDataWithTranslations>();

  return (
    <div className="flex flex-col gap-2 rounded-lg border border-brand-200 bg-brand-50 p-4">
      <Label className="text-gray-900 font-medium">
        {t('hotels.pasteFromExcel.expertMode.question')}
      </Label>
      <YesNoStyledRadioGroup control={control} name="expertMode" inline />
    </div>
  );
};

export default ExpertModeToggle;
